export enum OrderPageIntent {
  BUY_NOW = 'BUY_NOW',
  GIFT_CARD = 'GIFT_CARD',
  REDEEM_GIFT_CARD = 'REDEEM_GIFT_CARD',
  MANAGE_BOOKING = 'MANAGE_BOOKING',
}
